import * as React from "react";
import { ChartsContainer } from "@mui/x-charts/ChartsContainer";
import { LinePlot, MarkPlot } from "@mui/x-charts/LineChart";
import { ChartsXAxis } from "@mui/x-charts/ChartsXAxis";
import { ChartsYAxis } from "@mui/x-charts/ChartsYAxis";
import { ChartsTooltip } from "@mui/x-charts/ChartsTooltip";
import { ChartsAxisHighlight } from "@mui/x-charts/ChartsAxisHighlight"; // adds line where mouse is
import { ChartsGrid } from "@mui/x-charts/ChartsGrid";
import { LineHighlightPlot } from "@mui/x-charts/LineChart"; // adds dot where mouse is
import { ChartsReferenceLine } from "@mui/x-charts/ChartsReferenceLine";

import { DayLines, UncertaintyArea } from "./plotUtil";
import { round } from "./util";


function QFFConverter(array) {
  let q25 = array.data[0].map(function (x) {
    return x / 100;
  });
  let q50 = array.data[1].map(function (x) {
    return x / 100;
  });
  let q75 = array.data[2].map(function (x) {
    return x / 100;
  });
  return [q25, q50, q75];
}

export default function PressurePlot({ qff, label, label_plus, label_minus }) {
  const forecast_date = qff.coords.valid_time.data.map(
    (date) => new Date(date),
  );
  const current_time = Date.now();
  const midnight = forecast_date.filter((element) => element.getHours() === 0);
  // Load raw data
  const [qff_q25, qff_q50, qff_q75] = QFFConverter(qff);
  const id = React.useId();
  const clipPathId = `${id}-clip-path`;
  // Formatter
  const qffFormatter = (value) => `${round(value, 1)} hPa`;
  // Define plot view
  const max_qff = Math.max(...qff_q75);
  const min_qff = Math.min(...qff_q25);
  if ( Math.abs(max_qff) > Math.abs(min_qff) ) {
    var plot_max = Math.abs(max_qff);
  } else {
    var plot_max = Math.abs(min_qff);
  }

  return (
    <>
      <ChartsContainer
        sx={{ minWidth: 1235, mb: -2, ml: -2 }}
        series={[
          {
            yAxisId: "leftAxis",
            type: "line",
            data: qff_q50,
            showMark: false,
            label: `${label}`,
            valueFormatter: qffFormatter,
            color: "#1e50e6",
          },
        ]}
        xAxis={[
          {
            data: forecast_date,
            scaleType: "time",
            valueFormatter: (date, context) =>
              context.location === "tick"
                ? `${date.toLocaleDateString("de-DE", {
                    weekday: "short",
                    hour: "2-digit",
                  })}`
                : `${date.toLocaleDateString("de-DE", {
                    weekday: "long",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                  })} LT`,
            min: forecast_date.at(0),
            max: forecast_date.at(-1),
          },
        ]}
        yAxis={[
          {
            id: "leftAxis",
            label: "Druckdifferenz (hPa)",
            width: 50,
            position: "left",
            min: -plot_max,
            max: plot_max,
          },
          {
            id: "rightAxis",
            label: "Druckdifferenz (hPa)",
            width: 50,
            position: "right",
          },
        ]}
        height={180}
      >
        <ChartsXAxis />
        {/*<ChartsYAxis axisId="rightAxis" />*/}
        <ChartsYAxis axisId="leftAxis" />
        <g clipPath={`url(#${clipPathId})`}>
          <DayLines midnight={midnight} current_time={current_time} />
          <UncertaintyArea
            lower={qff_q25}
            upper={qff_q75}
            color={"#1e50e639"}
          />
          <ChartsReferenceLine
            y={plot_max-2}
            lineStyle={{ stroke: "#ffffff09" }}
            labelStyle={{ fontWeight: "bold", opacity: 0.5 }}
            label={label_plus}
          />
          <ChartsReferenceLine
            y={-plot_max+1}
            lineStyle={{ stroke: "#ffffff09" }}
            labelStyle={{ fontWeight: "bold", opacity: 0.5 }}
            label={label_minus}
          />
          <LinePlot />
        </g>
        <ChartsGrid horizontal="true" />
        <MarkPlot />
        <LineHighlightPlot />
        <ChartsAxisHighlight x="line" />
        <ChartsTooltip />
        {/* <ChartsClipPath id={clipPathId} /> */}
      </ChartsContainer>
    </>
  );
}
